define([], function () {
    'use strict';

    return {


        getUrlObject: function () {
            var location = window.location,
                search = decodeURIComponent(location.search),
                hash = decodeURIComponent(location.hash),
                i, l, v, params = {};

            search = search.replace("?", "").split("&");
            hash = hash.replace("#", "").split(";");

            for (i = 0, l = search.length; i < l; i++) {
                v = search[i].split("=");
                if (v[0]) {
                    params[v[0]] = v[1];
                }
            }

            for (i = 0, l = hash.length; i < l; i++) {
                v = hash[i].split("=");
                if (v[0]) {
                    params[v[0]] = v[1];
                }
            }

            return params;
        },

        get: function (param) {
            var params = this.getUrlObject();
            if (param) {
                return params[param];
            }
            else {
                return params;
            }
        },
        onlyURL: function (param) {
            window.history.replaceState( {} , 'browser.html', window.location.toString().substring(0,window.location.toString().indexOf("?")) );
        },

        getHash: function () {
            var hash = window.location.hash;
            if (hash.length) {
                hash = hash.substring(1);
            }
            if (hash.length) {
                return hash;
            }
            return '';
        }
    };
});
